(function () {
    'use strict';

    angular
        .module('app.scoring')
        .config(configRoutes);

    configRoutes.$inject = ['$stateProvider', 'scoringResolver', 'scoreHistoryResolver', 'handicapCalculationResolver', 'handicapCardResolver', 'handicapHistoryResolver', 'deletedScoresResolver'];
    function configRoutes($stateProvider, scoringResolver, scoreHistoryResolver, handicapCalculationResolver, handicapCardResolver, handicapHistoryResolver, deletedScoresResolver) {
        $stateProvider.state('scoring.history', {
            url: '',
            component: 'sc3ScoreHistory',
            resolve: scoreHistoryResolver
        });

        $stateProvider.state('scoring.deletedScores', {
            url: '/deleted-scores',
            component: 'sc3DeletedScores',
            resolve: deletedScoresResolver
        });


        $stateProvider.state('scoring.handicap-calculation', {
            url: '/handicap-calculation',
            component: 'sc3HandicapCalculation',
            resolve: handicapCalculationResolver
        });

        $stateProvider.state('scoring.handicap-card', {
            url: '/handicap-card',
            component: 'sc3HandicapCard',
            resolve: handicapCardResolver
        });

        $stateProvider.state('scoring.handicap-history', {
            url: '/handicap-history',
            component: 'sc3HandicapHistory',
            resolve: handicapHistoryResolver
        });
    }
})();